<script>
  import { createEventDispatcher } from 'svelte';
  export let title = '';
  export let open = false;
  export let wide = false;

  const dispatch = createEventDispatcher();

  function close() { dispatch('close'); }

  function handleKey(e) {
    if (e.key === 'Escape') close();
  }
</script>

<svelte:window on:keydown={handleKey} />

{#if open}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="overlay" on:click|self={close}>
    <div class="modal" class:wide role="dialog" aria-modal="true">
      <div class="modal-header">
        <h2 class="modal-title">{title}</h2>
        <button class="close-btn" on:click={close} aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <slot />
      </div>
    </div>
  </div>
{/if}

<style>
  .overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.85);
    z-index: 200;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    animation: fadeIn 0.15s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  .modal {
    background: #0f0f0f;
    border: 1px solid #2a5200;
    border-radius: 3px;
    width: 100%;
    max-width: 480px;
    max-height: 90vh;
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow:
      0 0 0 1px #1e3d00,
      0 0 40px rgba(74,124,0,0.2),
      0 20px 60px rgba(0,0,0,0.8);
    animation: slideUp 0.2s ease;
    position: relative;
  }

  .modal.wide { max-width: 640px; }

  @keyframes slideUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .modal::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #3a6b00, #6db800, #3a6b00, transparent);
    box-shadow: 0 0 8px rgba(109,184,0,0.6);
  }

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.25rem 1.25rem 0.75rem;
    border-bottom: 1px solid #1e3d00;
  }

  .modal-title {
    font-family: 'Rajdhani', sans-serif;
    font-weight: 700;
    font-size: 0.7rem;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    color: #6db800;
    text-shadow: 0 0 8px rgba(109,184,0,0.4);
  }

  .close-btn {
    background: none;
    border: 1px solid #1e3d00;
    color: #444;
    cursor: pointer;
    width: 28px; height: 28px;
    border-radius: 2px;
    display: flex; align-items: center; justify-content: center;
    transition: color 0.2s, border-color 0.2s;
    padding: 4px;
  }

  .close-btn:hover { color: #6db800; border-color: #3a6b00; }
  .close-btn svg { width: 14px; height: 14px; }

  .modal-body { padding: 1.25rem; overflow: hidden; }
</style>
